/* eslint react/no-array-index-key: 0 */
/* eslint jsx-a11y/label-has-associated-control: 0 */
import React from 'react'
import {
  Formik,
  Form,
  FieldArray,
} from 'formik'
import {
  FormFooter,
  FormWrapper,
  NewTableButton,
  SubmitButton,
  TableFormWrapper,
} from './styles'
import Icon from '../../../../../components/icon'
import FormActions from './form-actions'
import FieldGroup from '../../../../../components/form/form-factory/field-group'
import { If } from '../../../../../components/if/if'
import { ErrorMsg } from '../../../../../components/ui'

const FieldArrayComponent = FieldArray as any

const templateForm = {
  name: '',
  isActive: false,
  hasServiceCharge: '',
  serviceType: '',
  chargeType: '',
  chargeAmount: '',
}

const TablesForm = ({
  dataForm,
  initialData,
  onSubmit,
  setData,
  handleToggleModal,
  errorMessage,
  canAddMoreTable,
  isToUpdate = false,
}: any) => {
  const initialValues = initialData || { tables: [{ ...templateForm }] }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {(actions) => (
        <Form>
          <FieldArrayComponent name="tables">
            {({ remove, push }: any) => (
              <FormWrapper>
                <If condition={!isToUpdate && canAddMoreTable}>
                  <NewTableButton
                    type="button"
                    onClick={() => push(templateForm)}
                  >
                    <Icon name="plus" />
                    <span>Nova mesa</span>
                  </NewTableButton>
                </If>

                {actions.values.tables.length > 0
                  && actions.values.tables.map((table: any, index: number) => (
                    <div className="row" key={index}>
                      <TableFormWrapper>
                        <FieldGroup
                          prefixName={`tables.${index}.`}
                          actions={actions}
                          data={dataForm}
                          setData={setData}
                        />
                        <FormActions
                          hasDeleteButton={!isToUpdate}
                          remove={() => remove(index)}
                          handleQRCode={() => handleToggleModal(table)}
                        />
                      </TableFormWrapper>
                    </div>
                  ))}
              </FormWrapper>
            )}
          </FieldArrayComponent>
          <FormFooter>
            <SubmitButton type="submit">
              { actions.isSubmitting ? 'Salvando...' : 'Salvar' }
            </SubmitButton>
            <ErrorMsg>{errorMessage}</ErrorMsg>
          </FormFooter>
        </Form>
      )}
    </Formik>
  )
}

export default TablesForm
